import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function MetaPixelTracker() {
  const location = useLocation();
  const hasTrackedInitialPageView = useRef(false);

  useEffect(() => {
    if (!hasTrackedInitialPageView.current) {
      hasTrackedInitialPageView.current = true;
      return;
    }

    if (window.location.hostname.toLowerCase().startsWith('dev')) {
      return;
    }

    window.fbq?.('track', 'PageView');
  }, [location.pathname, location.search]);

  return null;
}
